// Lib
import React, { useCallback } from 'react';
import MobileEmojiSheet from '../../../emoji/popup/MobileEmojiSheet';
import { UseSheetReturnType } from '../../../../mobile/structural/sheet/hooks/useSheet';
import { useSelector } from 'react-redux';
import getGridSize from '../../../../utils/grid/gridSizeSelector';

interface MobileCalloutEmojiSheetProps {
    selectedEmojiId: string;
    sheetProps: UseSheetReturnType;
    onSelectEmoji: (emojiId: string) => void;
    closeSheet: () => void;
}

const MobileCalloutEmojiSheet: React.FC<MobileCalloutEmojiSheetProps> = (props) => {
    const { sheetProps, selectedEmojiId, closeSheet } = props;

    const gridSize = useSelector(getGridSize);

    const onSelectEmoji = useCallback((emojiId: string) => {
        props.onSelectEmoji?.(emojiId);
        sheetProps.dispatchCloseSheet();
    }, []);

    return (
        <MobileEmojiSheet
            {...props}
            heading="Choose an icon"
            sheetProps={sheetProps}
            gridSize={gridSize}
            selectedEmojiIds={[selectedEmojiId]}
            onSelectEmoji={onSelectEmoji}
            closePopup={closeSheet}
        />
    );
};

export default MobileCalloutEmojiSheet;
